import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarMonthViewDay,
  DAYS_OF_WEEK } from 'angular-calendar';
import { Subject } from 'rxjs/Subject';

export class CalendarOptions {
  public weekendDays: number[] = [DAYS_OF_WEEK.SATURDAY, DAYS_OF_WEEK.SUNDAY];
  public view: string = 'month';
  public viewDate: Date = new Date();
  public modalData: {
    action: string;
    event: CalendarEvent;
  };
  public refresh: Subject<any> = new Subject();
  public activeDayIsOpen: boolean = true;
  public events: CalendarEvent[] = [];
  public selectedMonthViewDay: CalendarMonthViewDay | any = {};
}

export class DateModel {
  public currentBookingOptions: any = null; // current data of widget
  public widgetIdForRouting: string = null; // widget id
  public changeDetectorRefTimeout: any = null;
  public timeoutDebounce: any = null;
  public calendarOptions: any = new CalendarOptions();
  public defaultDateValue: Date = new Date();
  public goTreatment: boolean = false;
  public locations: string[];

  constructor(currentBookingOptions: any, widgetIdForRouting: string) {
    this.currentBookingOptions = currentBookingOptions;
    this.widgetIdForRouting = widgetIdForRouting;
  }
}

export class DateStoreModel {
  public subscribtion: any = {
    booking$: null,
    data$: null,
    info$: null
  };
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/date/date.model.ts